import emailSupportImage from "@/app/common/assets/email-support.svg?url";
import webchatSupportImage from "@/app/common/assets/webchat-support.svg?url";
import serviceSupportImage from "@/app/common/assets/service-support.svg?url";

export const EmailSupport = {
  backgroundColor: "#F0F5FF",
  borderColor: "#D6E4FF",
  links: [
    {
      text: "Enviar por Gmail",
      url: `https://mail.google.com/mail/u/0/?to=${import.meta.env.VITE_SUPPORT_EMAIL}&fs=1&tf=cm`,
    },
    {
      text: "Enviar por Outlook",
      url: `https://outlook.office.com/mail/deeplink/compose?to=${
        import.meta.env.VITE_SUPPORT_EMAIL
      }`,
    },
  ],
  icon: emailSupportImage,
  title: {
    text: "Envíanos un correo",
  },
  description: {
    text: `Escribe tus dudas a nuestro correo ${
      import.meta.env.VITE_SUPPORT_EMAIL
    } y ten un registro de lo conversado en un solo lugar.`,
  },
};

export const WebChatSupport = {
  backgroundColor: "#FFFBE6",
  borderColor: "#FFF1B8",
  links: [
    {
      text: "Ir a Beex Community",
      url: "https://space.beexcc.com/acceso",
    },
  ],
  icon: webchatSupportImage,
  title: {
    text: "Chatea con el equipo de soporte",
  },
  description: {
    text: "Ingresa a Beex Community y escríbenos al webchat para resolver todas tus dudas y consultas.",
  },
};

export const ServiceSupport = {
  backgroundColor: "#F9F0FF",
  borderColor: "#EFDBFF",
  links: [
    {
      text: "Ir a Beex Help Center",
      url: "https://knowledge.beexcc.com/?_gl=1*1xt19y*_gcl_au*ODU5ODYwODgzLjE3NjczODg3MzIuMTczNDAzNDc5Ny4xNzcxODY0OTQ2LjE3NzE4NjYzNDI",
    },
  ],
  icon: serviceSupportImage,
  title: {
    text: "Explora nuestro centro de ayuda",
  },
  description: {
    text: "Accede a documentación completa de cada módulo en Beex Contact Center para guiarte en tus procesos.",
  },
};
